import React from "react";
import { useRouter } from "next/router";
import InfiniteScrollTrigger from "components/infinite-scroll/InfiniteScrollTrigger";
import CourseCard from "components/courses/CourseCard";
import { skeletonGenerator } from "components/infinite-scroll/helpers";
import ArticleSkeleton from "components/infinite-scroll/skeletons/ArticleSkeleton";

const CoursesList = ({
  courses,
  isLoadingNextPage,
  hasMoreItems,
  getNextPage,
  page,
  setPage,
}) => {
  const router = useRouter();
  return (
    <div className="w-full h-full overflow-y-auto">
      <div className="m-auto">
        <div className="p-8 flex flex-wrap justify-between gap-6 w-full">
          {!!courses.length &&
            courses.map((course, index) => {
              return (
                <CourseCard
                  key={index}
                  onClick={() => router.push(`/courses/${course.id}`)}
                  {...course}
                />
              );
            })}
          {isLoadingNextPage && skeletonGenerator(<ArticleSkeleton />)}
          <InfiniteScrollTrigger
            isLoading={isLoadingNextPage}
            hasMoreItems={hasMoreItems}
            callback={getNextPage}
            page={page}
            setPage={setPage}
          />
        </div>
      </div>
    </div>
  );
};

export default CoursesList;
